import React from "react";
import { Block } from "mosaic-react-icons";

const DoNotImportIcon = ({ size = 14 }) => (
    <Block sx={{ color: "text.secondary", fontSize: size }} />
);

export default DoNotImportIcon;
